/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import IsNotVerified from './IsNotVerified/index'
import No from './No/index'
import OtherError from './OtherError/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Error"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentProviderStatusValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
path: 'provider_status',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentProviderStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IsNotVerified'}>
<IsNotVerified
  viewPath={`${viewPath}/IsNotVerified`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherError'}>
<OtherError
  viewPath={`${viewPath}/OtherError`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}